import { useSearchParams } from 'react-router-dom'
import { capitalize, startCase } from 'lodash'
import { observer } from 'mobx-react-lite'
import { ScorecardsComponent } from 'app/components/scorecards/ScorecardsComponent'
import { useScorecards as useScorecardsPage } from 'app/components/scorecards/useScorecardsPage'

export const handle = {
  title: `Scorecards`,
  breadcrumb: (matches: any[]) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let [searchParams] = useSearchParams()
    let name = matches[0].data.subpages.find((subpage) => subpage.id === searchParams.get(`tab`))?.name
    return [
      <span key="scorecards" className="last:text-body-sm hover:text-subtle">
        Scorecards
      </span>,
      <span key={searchParams.get(`tab`)}>{capitalize(name) || startCase(searchParams.get(`tab`) ?? ``)}</span>,
    ]
  },
  pathname: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let [searchParams] = useSearchParams()
    return [`/scorecards`, `/scorecards?tab=${searchParams.get(`tab`)}`]
  },
}

export default observer(function Scorecards(): React.ReactElement {
  const hookData = useScorecardsPage()
  return <ScorecardsComponent {...hookData} />
})
